module.exports = __webpack_public_path__ + "static/media/Birds.4fd4efd0.webp";